module.exports = __webpack_public_path__ + "static/media/ppicon3.c726e01a.svg";